import { render, staticRenderFns } from "./FollowData.vue?vue&type=template&id=58450092&scoped=true&"
import script from "./FollowData.vue?vue&type=script&lang=js&"
export * from "./FollowData.vue?vue&type=script&lang=js&"
import style0 from "./FollowData.vue?vue&type=style&index=0&id=58450092&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58450092",
  null
  
)

export default component.exports